import * as yup from 'yup';

const FormSchema = yup.object({
  note: yup.string(),
});

export type TInputs = yup.InferType<typeof FormSchema>;

export default FormSchema;
